import React from 'react';
import { Bell, Settings, User, LogOut, ChevronDown } from 'lucide-react';
import { useSelector } from 'react-redux';


const Header = ({ title }) => {
  const { user } = useSelector((state) => state.profile);
  
  return (
    <header className="px-6 py-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          <p className="text-sm text-gray-500 mt-1">
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
      
      </div>
    </header>
  );
};

export default Header;